import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  Globe, Code, Smartphone, Zap, ArrowRight, Layout, Database, MonitorSmartphone,
  Shield, Rocket, CheckCircle2, Server, Layers, Paintbrush, Search, BarChart3,
  Terminal, GitBranch, Cloud, Lock, Cpu, Minus, MousePointer, Sparkles
} from 'lucide-react';
import SEO from './SEO';

/* ─── Client Logos ─── */
import logo1 from '../assets/logo.png';
import logo2 from '../assets/logo.jpeg';
import logo3 from '../assets/4 LOGO.png';
import logo4 from '../assets/LOGO (1).png';
import logo5 from '../assets/Rajaram g Food company Registered logo..png';
import logo6 from '../assets/Rise institute sangli.jpg.jpeg';
import logo7 from '../assets/Sunsspark Industrries main logo for website.png';
import logo8 from '../assets/WhatsApp Image 2025-08-05 at 16.25.03_52ef6ae1.jpg.jpeg';
import logo9 from '../assets/WhatsApp Image 2026-06-15 at 12.25.29 PM.jpeg';
import logo10 from '../assets/img1.png';
import logo11 from '../assets/WhatsApp Image 2026-06-15 at 12.28.00 PM.jpeg';
import logo12 from '../assets/WhatsApp Image 2026-06-15 at 12.31.28 PM.jpeg';
import logo13 from '../assets/cropped-VersatileScientiest.jpg.jpeg';
import logo14 from '../assets/gargi collection logo.jpg.jpeg';
import logo15 from '../assets/pixel11_main_logo-removebg-preview.png';
import logo16 from '../assets/223542549_106464955065874_4432653023872989525_n.jpg.jpeg';
import chappalBootLaptop from '../assets/Chapalboot laptop view.png';
import chappalBootMobile from '../assets/chapalboot mobileview.png';
import owlchemyLaptop from '../assets/owlchemylaptopview.png';
import owlchemyMobile from '../assets/owlchemymobileview.png';
import ishanviLaptop from '../assets/ishanvicraneslaptopview.png';
import ishanviMobile from '../assets/ishanvicranesmobileview.png';
import logo17 from '../assets/ChatGPT Image Jun 10, 2026, 09_31_13 PM.png';
import rushiLaptop from '../assets/rushigi-laptop.png';
import rushiMobile from '../assets/rushigi-mobile.png';
import huayuLaptop from '../assets/Huayumobile view.png';
import huayuMobile from '../assets/Huayu laptop view.png';
import versatileLaptop from '../assets/versatilescientis laptop view.png';
import versatileMobile from '../assets/versatilescientis mobile vieww.png';
import anusayaLaptop from '../assets/Ayurvediclaptopview.png';
import anusayaMobile from '../assets/Ayurvedicmobileview.png';
import imprintLaptop from '../assets/imprintlaptopview.png';
import imprintMobile from '../assets/imprintmobileview.png';
import rajaramLaptop from '../assets/Rajaramlaptopview.png';
import rajaramMobile from '../assets/Rajarammobileview.png';
import riseLaptop from '../assets/riseinsitutelaptopview.png';
import riseMobile from '../assets/riseinsitutemobileview.png';
import pixel11Laptop from '../assets/pixel11-laptop.png';
import pixel11Mobile from '../assets/pixel11-mobile.png';
import sunssparkLaptop from '../assets/sunsparklaptopview.png';
import sunssparkMobile from '../assets/sunsparkmobileview.png';

/* ─── Animated Counter ─── */
const AnimatedCounter = ({ target, suffix = '' }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting && !hasAnimated) setHasAnimated(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    const cur = ref.current;
    return () => { if (cur) observer.unobserve(cur); };
  }, [hasAnimated]);

  useEffect(() => {
    if (!hasAnimated) return;
    const end = parseInt(target, 10);
    const duration = 2200;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const ease = 1 - Math.pow(1 - p, 4);
      setCount(Math.floor(end * ease));
      if (p < 1) requestAnimationFrame(step); else setCount(end);
    };
    requestAnimationFrame(step);
  }, [hasAnimated, target]);

  return <span ref={ref}>{count}{suffix}</span>;
};

const WebsitesDevelopment = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeProject, setActiveProject] = useState('rushigi');

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  /* ─── Data ─── */
  const bentoFeatures = [
    {
      title: "Custom Web Applications",
      description: "We architect bespoke, scalable web apps from the ground up using React, Next.js, and modern cloud-native APIs — no templates, no shortcuts.",
      icon: Code,
      color: "text-cyan-400",
      glow: "bg-cyan-400/20",
      borderHover: "hover:border-cyan-500/40",
      span: "md:col-span-2 md:row-span-2",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=2070&auto=format&fit=crop",
      bullets: ["React / Next.js Architecture", "RESTful & GraphQL APIs", "CI/CD Pipelines"]
    },
    {
      title: "Responsive Design",
      description: "Pixel-perfect, fluid layouts that adapt flawlessly across every screen size.",
      icon: MonitorSmartphone,
      color: "text-violet-400",
      glow: "bg-violet-400/20",
      borderHover: "hover:border-violet-500/40",
      span: "md:col-span-1 md:row-span-1"
    },
    {
      title: "E-Commerce Engines",
      description: "High-converting storefronts with secure payments, inventory management, and blazing-fast UX.",
      icon: Layout,
      color: "text-amber-400",
      glow: "bg-amber-400/20",
      borderHover: "hover:border-amber-500/40",
      span: "md:col-span-1 md:row-span-1"
    },
    {
      title: "SEO & Performance",
      description: "Core Web Vitals optimized. Server-side rendering, edge caching, and structured data for maximum search visibility.",
      icon: Search,
      color: "text-emerald-400",
      glow: "bg-emerald-400/20",
      borderHover: "hover:border-emerald-500/40",
      span: "md:col-span-1 md:row-span-1"
    },
    {
      title: "CMS & Admin Panels",
      description: "Intuitive content management systems and powerful admin dashboards tailored to your workflow.",
      icon: Database,
      color: "text-rose-400",
      glow: "bg-rose-400/20",
      borderHover: "hover:border-rose-500/40",
      span: "md:col-span-2 md:row-span-1"
    }
  ];

  const processSteps = [
    { num: "01", title: "Discovery & Strategy", desc: "Deep dive into your business goals, audience, and competitive landscape to craft a winning digital strategy.", icon: Sparkles, color: "from-cyan-500 to-blue-600" },
    { num: "02", title: "UI/UX Design", desc: "Interactive wireframes and high-fidelity prototypes that bring your vision to life before a single line of code.", icon: Paintbrush, color: "from-violet-500 to-purple-600" },
    { num: "03", title: "Agile Development", desc: "Two-week sprints delivering testable, production-ready code using modern frameworks and best practices.", icon: Terminal, color: "from-emerald-500 to-teal-600" },
    { num: "04", title: "QA & Security Audit", desc: "Rigorous cross-browser testing, performance benchmarks, and comprehensive security hardening.", icon: Shield, color: "from-amber-500 to-orange-600" },
    { num: "05", title: "Launch & Scale", desc: "Zero-downtime deployment to auto-scaling cloud infrastructure with 24/7 monitoring and support.", icon: Rocket, color: "from-rose-500 to-pink-600" }
  ];

  const technologies = [
    { name: "React.js", icon: "⚛️" },
    { name: "Next.js", icon: "▲" },
    { name: "Node.js", icon: "🟢" },
    { name: "TypeScript", icon: "🔷" },
    { name: "MongoDB", icon: "🍃" },
    { name: "PostgreSQL", icon: "🐘" },
    { name: "Tailwind CSS", icon: "🎨" },
    { name: "AWS Cloud", icon: "☁️" },
    { name: "Firebase", icon: "🔥" },
    { name: "Docker", icon: "🐳" },
    { name: "GraphQL", icon: "◈" },
    { name: "Redis", icon: "🔴" }
  ];

  const stats = [
    { number: "150", suffix: "+", label: "Websites Delivered", icon: Globe, color: "from-cyan-400 to-blue-400" },
    { number: "99", suffix: "%", label: "Client Satisfaction", icon: CheckCircle2, color: "from-emerald-400 to-teal-400" },
    { number: "50", suffix: "ms", label: "Avg. Load Time", icon: Zap, color: "from-amber-400 to-yellow-400" },
    { number: "24", suffix: "/7", label: "Support & Uptime", icon: Shield, color: "from-violet-400 to-purple-400" }
  ];

  return (
    <div className="bg-[#030712] min-h-screen text-white pt-20 overflow-hidden selection:bg-cyan-500 selection:text-white" style={{ fontFamily: 'emoji' }}>
      <SEO
        title="Website Development Services in Sangli – Vishwa DigiTech"
        description="Get professional website development services in Sangli. Vishwa DigiTech builds fast, responsive, SEO-optimized websites using React, Next.js & modern tech. Ecommerce, business, portfolio websites."
        keywords="website development sangli, web design sangli, react website sangli, responsive website india, ecommerce website sangli, custom website development maharashtra"
        canonicalPath="/services/websites"
      />
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(-1deg); }
          50% { transform: translateY(-12px) rotate(1deg); }
        }
        @keyframes float-slow {
          0%, 100% { transform: translateY(0) rotate(1deg); }
          50% { transform: translateY(10px) rotate(-1deg); }
        }
        @keyframes grid-pulse {
          0%, 100% { opacity: 0.03; }
          50% { opacity: 0.08; }
        }
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes orbit {
          0% { transform: rotate(0deg) translateX(120px) rotate(0deg); }
          100% { transform: rotate(360deg) translateX(120px) rotate(-360deg); }
        }
        @keyframes code-scroll {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        .animate-float { animation: float 6s ease-in-out infinite; }
        .animate-float-slow { animation: float-slow 8s ease-in-out infinite; }
        .animate-grid-pulse { animation: grid-pulse 4s ease-in-out infinite; }
        .animate-shimmer {
          background: linear-gradient(90deg, transparent 0%, rgba(14,165,233,0.15) 50%, transparent 100%);
          background-size: 200% 100%;
          animation: shimmer 3s ease-in-out infinite;
        }
        .animate-orbit { animation: orbit 20s linear infinite; }
        .animate-code-scroll { animation: code-scroll 20s linear infinite; }
        @keyframes client-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-client-marquee {
          animation: client-marquee 35s linear infinite;
        }
        .animate-client-marquee:hover {
          animation-play-state: paused;
        }
        .perspective-1000 { perspective: 1000px; }
        .glass-card {
          background: rgba(10, 15, 31, 0.5);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
        }
        @keyframes text-reveal {
          0% { opacity: 0; transform: translateY(40px) scale(0.95); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .animate-text-reveal { animation: text-reveal 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animate-text-reveal-delayed { opacity: 0; animation: text-reveal 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.3s forwards; }
        .animate-text-reveal-delayed-2 { opacity: 0; animation: text-reveal 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards; }
        .animate-gradient-x {
          background-size: 200% auto;
          animation: gradient-x 4s linear infinite;
        }
      `}</style>

      {/* ═══════════════════════════════════════════════════════
          SECTION 1 — IMMERSIVE HERO
      ═══════════════════════════════════════════════════════ */}
      <section className="relative min-h-[95vh] flex items-center justify-center pt-10 border-b border-white/5 overflow-hidden">
        {/* Animated Grid Background */}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJub25lIiBzdHJva2U9InJnYmEoMTQsMTY1LDIzMywwLjA4KSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9zdmc+')] animate-grid-pulse" />
          {/* Large glowing orbs */}
          <div className="absolute top-1/4 right-1/6 w-[700px] h-[700px] bg-cyan-500/15 rounded-full blur-[180px] mix-blend-screen animate-pulse" />
          <div className="absolute bottom-1/3 left-1/5 w-[500px] h-[500px] bg-violet-600/10 rounded-full blur-[150px] mix-blend-screen" style={{ animationDelay: '3s' }} />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-blue-800/8 rounded-full blur-[200px]" />
          {/* Gradient fade */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#030712]/60 to-[#030712]" />
        </div>

        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}`}>
          <div className="grid lg:grid-cols-2 gap-16 items-center">

            {/* Left — Copy */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                <Sparkles className="w-4 h-4" />
                Web Development Studio
              </div>

              <h1 className="text-6xl md:text-7xl lg:text-[90px] font-black leading-[1.05] tracking-tight mb-8 animate-text-reveal">
                <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-400">Architecting</span><br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Digital Futures.</span>
              </h1>

              <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-lg leading-relaxed font-light animate-text-reveal-delayed">
                We forge high-performance, enterprise-grade web solutions that elevate brands, engage audiences, and drive measurable global impact.
              </p>

              <div className="flex flex-col sm:flex-row gap-5">
                <Link to="/contact" className="group relative px-8 py-4 bg-white text-[#030712] rounded-2xl font-black tracking-wide overflow-hidden hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(14,165,233,0.3)] no-underline inline-block">
                  <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300 ease-in-out" />
                  <span className="relative z-10 flex items-center justify-center gap-3 group-hover:text-white transition-colors">
                    Start Your Project <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
                <button className="flex items-center justify-center gap-3 px-8 py-4 rounded-2xl font-bold text-white border border-white/10 bg-white/5 hover:bg-white/10 backdrop-blur-md transition-all duration-300 hover:border-cyan-500/30">
                  <MousePointer className="w-5 h-5 text-cyan-400" /> View Portfolio
                </button>
              </div>


            </div>

            {/* Right — Browser Mockup with Live Code */}
            <div className="relative hidden lg:block perspective-1000">
              {/* Orbiting dot */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px]">
                <div className="animate-orbit">
                  <div className="w-3 h-3 rounded-full bg-cyan-400 shadow-[0_0_20px_rgba(14,165,233,0.8)]" />
                </div>
              </div>

              <div className="relative animate-float">
                {/* Browser Chrome */}
                <div className="rounded-[2rem] border border-white/10 bg-[#0A0F1F]/90 backdrop-blur-xl shadow-[0_0_80px_rgba(14,165,233,0.15)] overflow-hidden">
                  {/* Title bar */}
                  <div className="flex items-center gap-3 px-6 py-4 border-b border-white/5 bg-white/[0.02]">
                    <div className="flex gap-2">
                      <div className="w-3 h-3 rounded-full bg-red-500/80" />
                      <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
                      <div className="w-3 h-3 rounded-full bg-green-500/80" />
                    </div>
                    <div className="flex-1 mx-4">
                      <div className="flex items-center gap-2 px-4 py-1.5 rounded-lg bg-white/5 border border-white/5 text-xs text-gray-500 font-mono">
                        <Lock className="w-3 h-3 text-green-400" />
                        https://yourproject.com
                      </div>
                    </div>
                  </div>

                  {/* Fake code editor */}
                  <div className="p-6 h-[420px] overflow-hidden relative">
                    <div className="animate-code-scroll space-y-2 font-mono text-sm">
                      {[
                        { c: 'text-violet-400', t: 'import' },
                        { c: 'text-gray-400', t: '  React,' },
                        { c: 'text-gray-400', t: '  { useState, useEffect }' },
                        { c: 'text-violet-400', t: "from 'react';" },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-cyan-400', t: 'const App = () => {' },
                        { c: 'text-amber-400', t: '  const [data, setData] = useState([]);' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-violet-400', t: '  useEffect(() => {' },
                        { c: 'text-emerald-400', t: "    fetch('/api/data')" },
                        { c: 'text-emerald-400', t: '      .then(r => r.json())' },
                        { c: 'text-emerald-400', t: '      .then(setData);' },
                        { c: 'text-violet-400', t: '  }, []);' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-cyan-400', t: '  return (' },
                        { c: 'text-rose-400', t: '    <main className="app">' },
                        { c: 'text-rose-400', t: '      <Header />' },
                        { c: 'text-rose-400', t: '      <Dashboard data={data} />' },
                        { c: 'text-rose-400', t: '      <Analytics />' },
                        { c: 'text-rose-400', t: '    </main>' },
                        { c: 'text-cyan-400', t: '  );' },
                        { c: 'text-cyan-400', t: '};' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-violet-400', t: 'export default App;' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-gray-500', t: '// Built with ❤️ by VishwaDigitech' },
                      ].concat([
                        { c: 'text-violet-400', t: 'import' },
                        { c: 'text-gray-400', t: '  React,' },
                        { c: 'text-gray-400', t: '  { useState, useEffect }' },
                        { c: 'text-violet-400', t: "from 'react';" },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-cyan-400', t: 'const App = () => {' },
                        { c: 'text-amber-400', t: '  const [data, setData] = useState([]);' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-violet-400', t: '  useEffect(() => {' },
                        { c: 'text-emerald-400', t: "    fetch('/api/data')" },
                        { c: 'text-emerald-400', t: '      .then(r => r.json())' },
                        { c: 'text-emerald-400', t: '      .then(setData);' },
                        { c: 'text-violet-400', t: '  }, []);' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-cyan-400', t: '  return (' },
                        { c: 'text-rose-400', t: '    <main className="app">' },
                        { c: 'text-rose-400', t: '      <Header />' },
                        { c: 'text-rose-400', t: '      <Dashboard data={data} />' },
                        { c: 'text-rose-400', t: '      <Analytics />' },
                        { c: 'text-rose-400', t: '    </main>' },
                        { c: 'text-cyan-400', t: '  );' },
                        { c: 'text-cyan-400', t: '};' },
                        { c: 'text-gray-600', t: '' },
                        { c: 'text-violet-400', t: 'export default App;' },
                      ]).map((line, i) => (
                        <div key={i} className="flex items-center gap-4">
                          <span className="text-gray-600 w-6 text-right select-none text-xs">{(i % 26) + 1}</span>
                          <span className={line.c}>{line.t || '\u00A0'}</span>
                        </div>
                      ))}
                    </div>
                    {/* Gradient fade at bottom */}
                    <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0A0F1F] to-transparent pointer-events-none" />
                    {/* Shimmer overlay */}
                    <div className="absolute inset-0 animate-shimmer pointer-events-none" />
                  </div>
                </div>

                {/* Floating notification card */}
                <div className="absolute -bottom-6 -left-8 glass-card rounded-2xl border border-white/10 p-4 shadow-2xl animate-float-slow z-20">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
                      <Zap className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-white">Performance A+</p>
                      <p className="text-xs text-gray-400">Lighthouse Score: 98</p>
                    </div>
                  </div>
                </div>

                {/* Floating security badge */}
                <div className="absolute -top-4 -right-6 glass-card rounded-2xl border border-white/10 p-4 shadow-2xl animate-float z-20" style={{ animationDelay: '2s' }}>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                      <Shield className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-white">SSL Secured</p>
                      <p className="text-xs text-gray-400">256-bit Encryption</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION 2 — STATS COUNTER BAR
      ═══════════════════════════════════════════════════════ */}
      <section className="py-16 relative z-10 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative rounded-[2.5rem] bg-[#0A0F1F]/60 backdrop-blur-xl border border-white/[0.06] shadow-[0_0_60px_rgba(14,165,233,0.08)] overflow-hidden">
            {/* Top shimmer line */}
            <div className="absolute top-0 left-1/4 w-1/2 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" />
            <div className="absolute bottom-0 right-1/4 w-1/2 h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" />

            <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/5 relative z-10">
              {stats.map((stat, idx) => (
                <div key={idx} className="p-10 lg:p-12 flex flex-col items-center justify-center group hover:bg-white/[0.02] transition-colors duration-500 cursor-default">
                  <div className="relative mb-5">
                    <div className={`absolute inset-0 bg-gradient-to-r ${stat.color} blur-xl opacity-0 group-hover:opacity-40 transition-opacity duration-500 rounded-full scale-150`} />
                    <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500 shadow-xl relative z-10">
                      <stat.icon className="w-7 h-7 text-white group-hover:text-cyan-400 transition-colors duration-300" />
                    </div>
                  </div>
                  <h3 className="text-4xl md:text-5xl font-black mb-2 tracking-tighter bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-500 group-hover:from-white group-hover:to-white transition-all duration-500">
                    <AnimatedCounter target={stat.number} suffix={stat.suffix} />
                  </h3>
                  <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px] md:text-xs text-center group-hover:text-cyan-400 transition-colors duration-300 mt-1">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION 3 — OUR EXPERTISE (Redesigned)
      ═══════════════════════════════════════════════════════ */}
      <section className="py-32 relative z-10 overflow-hidden">
        {/* Floating background accents */}
        <div className="absolute top-20 left-1/4 w-[600px] h-[600px] bg-cyan-500/8 rounded-full blur-[200px] pointer-events-none" />
        <div className="absolute bottom-20 right-1/4 w-[500px] h-[500px] bg-violet-500/8 rounded-full blur-[180px] pointer-events-none" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header — centered */}
          <div className="text-center mb-24">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md">
              <Sparkles className="w-4 h-4" />
              Our Expertise
            </div>
            <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
              Enterprise-Grade<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Web Solutions</span>
            </h2>
            <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
              From pixel-perfect landing pages to complex SaaS platforms — we architect digital experiences that drive growth.
            </p>
          </div>

          {/* Featured Card — Full Width */}
          <div className="mb-8">
            <div className="group relative overflow-hidden rounded-[2rem] border border-white/[0.06] hover:border-cyan-500/30 transition-all duration-700 cursor-default">
              {/* Animated gradient border */}
              <div className="absolute -inset-[1px] rounded-[2rem] bg-gradient-to-r from-cyan-500/0 via-cyan-500/30 to-violet-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-[1px]" />

              <div className="relative grid lg:grid-cols-2 gap-0 bg-[#0A0F1F]/70 backdrop-blur-xl rounded-[2rem] overflow-hidden">
                {/* Left — Content */}
                <div className="p-10 md:p-14 flex flex-col justify-center relative z-10">
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-500/20 to-cyan-500/5 border border-cyan-500/20 flex items-center justify-center mb-8 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500`}>
                    <Code className="w-8 h-8 text-cyan-400" />
                  </div>
                  <h3 className="text-3xl md:text-4xl font-black text-white mb-4 tracking-tight">Custom Web Applications</h3>
                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We architect bespoke, scalable web apps from the ground up using React, Next.js, and modern cloud-native APIs — no templates, no shortcuts.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {["React / Next.js Architecture", "RESTful & GraphQL APIs", "CI/CD Pipelines"].map((tag, i) => (
                      <span key={i} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-sm font-medium">
                        <CheckCircle2 className="w-3.5 h-3.5" />
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Right — Visual */}
                <div className="relative min-h-[320px] lg:min-h-0 overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=2070&auto=format&fit=crop"
                    alt="Custom Web Applications"
                    className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1F] via-[#0A0F1F]/60 to-transparent" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1F]/80 via-transparent to-transparent" />
                  {/* Floating code snippet overlay */}
                  <div className="absolute bottom-8 right-8 glass-card rounded-2xl border border-white/10 p-5 shadow-2xl opacity-80 group-hover:opacity-100 transition-opacity duration-500 hidden md:block">
                    <div className="font-mono text-xs space-y-1.5">
                      <div><span className="text-violet-400">const</span> <span className="text-cyan-300">app</span> <span className="text-white">=</span> <span className="text-amber-400">createApp</span><span className="text-gray-400">();</span></div>
                      <div><span className="text-cyan-300">app</span><span className="text-gray-400">.</span><span className="text-amber-400">deploy</span><span className="text-gray-400">(</span><span className="text-emerald-400">'production'</span><span className="text-gray-400">);</span></div>
                      <div className="text-emerald-400">✓ Deployed successfully</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grid — 4 Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: "Responsive Design", description: "Pixel-perfect, fluid layouts that adapt flawlessly across every screen — mobile, tablet, and ultra-wide.", icon: MonitorSmartphone, color: "violet", gradient: "from-violet-500 to-purple-600" },
              { title: "E-Commerce Engines", description: "High-converting storefronts with secure payments, inventory management, and blazing-fast UX.", icon: Layout, color: "amber", gradient: "from-amber-500 to-orange-600" },
              { title: "SEO & Performance", description: "Core Web Vitals optimized. SSR, edge caching, and structured data for maximum search visibility.", icon: Search, color: "emerald", gradient: "from-emerald-500 to-teal-600" },
              { title: "CMS & Admin Panels", description: "Intuitive content management systems and powerful admin dashboards tailored to your workflow.", icon: Database, color: "rose", gradient: "from-rose-500 to-pink-600" }
            ].map((feature, idx) => (
              <div
                key={idx}
                className="group relative overflow-hidden rounded-[2rem] border border-white/[0.06] hover:border-white/15 bg-[#0A0F1F]/50 backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 cursor-default"
              >
                {/* Animated gradient border on hover */}
                <div className={`absolute -inset-[1px] rounded-[2rem] bg-gradient-to-b from-${feature.color}-500/0 via-${feature.color}-500/20 to-${feature.color}-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-[1px]`} />

                <div className="relative p-8 flex flex-col h-full min-h-[320px] bg-[#0A0F1F]/50 rounded-[2rem]">
                  {/* Glow orb */}
                  <div className={`absolute -top-16 -right-16 w-40 h-40 bg-${feature.color}-500/20 blur-[80px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700`} />

                  {/* Icon with gradient bg */}
                  <div className="relative z-10 mb-auto">
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500 shadow-lg`}>
                      <feature.icon className="w-7 h-7 text-white" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="relative z-10 mt-8">
                    <h3 className="text-xl font-bold text-white mb-3 tracking-wide group-hover:text-white transition-colors">{feature.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed font-light group-hover:text-gray-300 transition-colors">{feature.description}</p>
                  </div>

                  {/* Bottom arrow indicator */}
                  <div className="relative z-10 mt-6 flex items-center gap-2 text-gray-500 group-hover:text-white text-sm font-medium transition-colors duration-300">
                    <span>Learn more</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION — PORTFOLIO SHOWCASE
      ═══════════════════════════════════════════════════════ */}
      <div id="portfolio-showcase" className="scroll-mt-20">
        {activeProject === 'rushigi' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-violet-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-cyan-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">
                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-cyan-500/15 to-violet-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(14,165,233,0.2)] border border-white/10">
                      <img
                        src={rushiLaptop}
                        alt="Rushi Group Of Industries — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(139,92,246,0.25)] border border-white/10">
                      <img
                        src={rushiMobile}
                        alt="Rushi Group Of Industries — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">rushigi.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-emerald-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Client Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Rushi Group<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Of Industries</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed and developed a modern, professional corporate website for Rushi Group Of Industries — delivering a clean UI, seamless navigation, fast load times, and a fully responsive experience across all devices.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Fully Responsive Design",
                      "SEO Optimized Pages",
                      "Lightning Fast Performance",
                      "Modern UI/UX Design",
                      "Cross-Browser Compatible",
                      "Mobile-First Approach"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://rushigi.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeProject === 'anusaya' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-blue-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-emerald-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Project Info (Swapped order for alternate layout) */}
                <div className="order-2 lg:order-1">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Healthcare Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Anusaya<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">Hospital</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We developed a highly accessible and professional medical website for Anusaya Hospital. The platform features integrated appointment booking, doctor profiles, comprehensive healthcare services, and an empathetic UI tailored for patients.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Patient-First UI/UX",
                      "Appointment Scheduling",
                      "Mobile Responsive",
                      "Medical Services Directory",
                      "Fast Load Speeds",
                      "Secure & Reliable"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://anusaya.online"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-blue-600 to-emerald-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(59,130,246,0.3)] hover:shadow-[0_0_60px_rgba(59,130,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

                {/* Right — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px] order-1 lg:order-2">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-blue-500/15 to-emerald-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(59,130,246,0.2)] border border-white/10">
                      <img
                        src={anusayaLaptop}
                        alt="Anusaya Hospital — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(16,185,129,0.25)] border border-white/10">
                      <img
                        src={anusayaMobile}
                        alt="Anusaya Hospital — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">anusaya.online</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        )}
        {activeProject === 'huayuintelligent' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-sky-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-sky-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Industrial Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Huayu<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-blue-400">Intelligent</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed a robust corporate website for Huayu Intelligent, an industry leader in elevator manufacturing and maintenance. The site highlights their high-tech elevator systems, safety standards, and global projects.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Smart Elevator Systems",
                      "Global Safety Standards",
                      "Interactive Product Catalog",
                      "Maintenance & Service Portal",
                      "High-Rise Project Portfolio",
                      "B2B Client Integration"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-sky-500 to-blue-500 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://huayuintelligent.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-sky-600 to-blue-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(14,165,233,0.3)] hover:shadow-[0_0_60px_rgba(14,165,233,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

                {/* Right — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-sky-500/15 to-blue-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(14,165,233,0.2)] border border-white/10">
                      <img
                        src={huayuLaptop}
                        alt="Huayu Intelligent — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(139,92,246,0.25)] border border-white/10">
                      <img
                        src={huayuMobile}
                        alt="Huayu Intelligent — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-500 to-blue-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">huayuintelligent.com</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        )}
        {activeProject === 'versatilescientist' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-blue-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-cyan-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">
                
                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-blue-500/15 to-cyan-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(59,130,246,0.2)] border border-white/10">
                      <img
                        src={versatileLaptop}
                        alt="Versatile Scientist — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(6,182,212,0.25)] border border-white/10">
                      <img
                        src={versatileMobile}
                        alt="Versatile Scientist — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">versatilescientist.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Educational Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Versatile<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Scientist</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We developed a comprehensive educational hub for Versatile Scientist, empowering students and professionals by providing access to the latest Scholarships, Internships, and Job opportunities across the globe.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Global Scholarship Alerts",
                      "Internship Opportunities",
                      "Job Board & Placements",
                      "Educational Resources",
                      "Mobile-Optimized Layout",
                      "Fast Loading Speed"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://www.versatilescientist.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(59,130,246,0.3)] hover:shadow-[0_0_60px_rgba(59,130,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}
        {activeProject === 'sunsspark' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-blue-600/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-sky-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">
                
                {/* Left — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-500" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Manufacturing Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Sunsspark<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-sky-400">Industries</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We developed a robust corporate presence for Sunsspark Industries, highlighting their expertise in manufacturing precision machine parts, gunmetal, bronze, and brass castings.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Precision Machine Parts",
                      "Gunmetal & Bronze Castings",
                      "Pumps & Valves Components",
                      "Heavy Engineering Solutions",
                      "Industrial B2B Portal",
                      "Foundry Capabilities"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-blue-600 to-sky-500 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://sunssparkindustrries.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-blue-700 to-sky-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(3,78,153,0.4)] hover:shadow-[0_0_60px_rgba(3,78,153,0.6)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

                {/* Right — Project Images */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-blue-600/15 to-sky-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(3,78,153,0.25)] border border-white/10">
                      <img
                        src={sunssparkLaptop}
                        alt="Sunsspark Industries — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(14,165,233,0.25)] border border-white/10">
                      <img
                        src={sunssparkMobile}
                        alt="Sunsspark Industries — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-sky-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">sunssparkindustrries.com</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        )}
        {activeProject === 'pixel11' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-blue-600/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-sky-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">
                
                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-blue-600/15 to-sky-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(3,78,153,0.25)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={pixel11Laptop}
                        alt="Pixel11 — Desktop View"
                        className="w-full max-w-[520px] aspect-[4/3] object-cover rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(14,165,233,0.25)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={pixel11Mobile}
                        alt="Pixel11 — Mobile View"
                        className="w-[140px] md:w-[180px] aspect-[9/16] object-cover rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-sky-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">pixel11.in</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-500" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Digital Agency</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Pixel<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-sky-400">11</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    Pixel11 is a creativity-enhanced-by-AI digital agency delivering branding, media production, website development, and system automation for scalable business growth.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "AI-Enhanced Creativity",
                      "Branding & Strategy",
                      "Media Production",
                      "Website Development",
                      "System Automation",
                      "Scalable Solutions"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-blue-600 to-sky-500 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://pixel11.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-blue-700 to-sky-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(3,78,153,0.4)] hover:shadow-[0_0_60px_rgba(3,78,153,0.6)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

              </div>
            </div>
          </section>
        )}
        {activeProject === 'chappalboot' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-cyan-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-violet-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Project Info (swapped for alternate layout) */}
                <div className="order-2 lg:order-1">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-cyan-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">E-Commerce Project</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    चप्पल<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Boot.com</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We built a fully functional e-commerce platform for चप्पलBoot, Pune's leading online footwear store. The platform features seamless product browsing, secure checkout, and a mobile-first shopping experience.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Online Footwear Store",
                      "Secure Payment Gateway",
                      "Mobile-First Design",
                      "Product Catalog & Filters",
                      "Order Management System",
                      "Fast & Responsive UI"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://www.chappalboot.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

                {/* Right — Device Mockups */}
                <div className="order-1 lg:order-2 relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-cyan-500/15 to-violet-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(14,165,233,0.2)] border border-white/10">
                      <img
                        src={chappalBootLaptop}
                        alt="ChappalBoot — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(139,92,246,0.25)] border border-white/10">
                      <img
                        src={chappalBootMobile}
                        alt="ChappalBoot — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">chappalboot.com</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        )}

        {activeProject === 'coderspixel' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-violet-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-cyan-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-violet-500/15 to-cyan-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(139,92,246,0.2)] border border-white/10">
                      <img
                        src={imprintLaptop}
                        alt="Coders Pixel Innovations — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(139,92,246,0.25)] border border-white/10">
                      <img
                        src={imprintMobile}
                        alt="Coders Pixel Innovations — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">coderspixelinnovations.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-emerald-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Imprint24
    
                    </span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Photo<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Frames</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed and developed a modern, professional e-commerce website for Coders Pixel Innovations (Imprint24) — a personalized photo printing & framing store. The platform sells Acrylic Photo Frames, Canvas Prints, Light Photo Frames, God Photo Frames, and Standy Displays with a complete product catalog, cart system, and seamless shopping experience.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Acrylic & Canvas Photo Frames",
                      "Light & God Photo Frames",
                      "Standy Displays & Prints",
                      "Add to Cart & Buy Now System",
                      "Mobile-First Responsive Design",
                      "SEO Optimized Performance"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://coderspixelinnovations.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeProject === 'rajaram' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-cyan-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-violet-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-cyan-500/15 to-violet-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(139,92,246,0.2)] border border-white/10">
                      <img
                        src={rajaramLaptop}
                        alt="Rajaram Food Company — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(14,165,233,0.25)] border border-white/10">
                      <img
                        src={rajaramMobile}
                        alt="Rajaram Food Company — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">rajaramgfoodcompany.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-cyan-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">RAJARAM-G</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Rajaram G Food<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Company</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed a dynamic, professional website for Rajaram G Food Company — a growing Indian food company specializing in premium Instant Masala Tea, Jaggery Tea, and Coffee premixes for commercial and domestic utility.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Instant Tea & Coffee Premixes",
                      "Signature Jaggery Tea Formulation",
                      "Commercial & Domestic Utility",
                      "Premium Ingredients Quality",
                      "Quick Preparation (Just Add Water)",
                      "Consistent Taste Guarantee"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://rajaramgfoodcompany.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeProject === 'owlchemy' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] bg-blue-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-indigo-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Project Info */}
                <div className="order-2 lg:order-1">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-blue-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Social Media Agency</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Owlchemy<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Digital</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed a premium online presence for Owlchemy, a specialized agency focusing on LinkedIn and Social Media Management. The platform highlights their expertise in B2B lead generation, brand building, and content strategy to help businesses scale their digital footprint.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "LinkedIn Profile Optimization",
                      "B2B Lead Generation",
                      "Social Media Management",
                      "Content Creation & Strategy",
                      "Brand Building & Engagement",
                      "Analytics & Reporting"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://owlchemy.co"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(79,70,229,0.3)] hover:shadow-[0_0_60px_rgba(79,70,229,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>

                {/* Right — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px] order-1 lg:order-2">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-blue-500/15 to-indigo-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(79,70,229,0.2)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={owlchemyLaptop}
                        alt="Owlchemy — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl object-cover"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -left-2 md:-left-8 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(59,130,246,0.25)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={owlchemyMobile}
                        alt="Owlchemy — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem] object-cover"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -right-2 md:right-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">owlchemy.co</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        )}

        {activeProject === 'ishanvi' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-cyan-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-violet-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-cyan-500/15 to-violet-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(139,92,246,0.2)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={ishanviLaptop}
                        alt="Ishanvi Cranes — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl object-cover"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(14,165,233,0.25)] border border-white/10 bg-[#0A0F1F]">
                      <img
                        src={ishanviMobile}
                        alt="Ishanvi Cranes — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem] object-cover"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">ishanvicranes.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-cyan-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Industrial Manufacturing</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Ishanvi<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Cranes</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We built a comprehensive corporate website for Ishanvi Cranes, a leading industrial crane manufacturer in India. The platform showcases their heavy-duty lifting solutions including EOT cranes, gantry cranes, jib cranes, and industrial hoists.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "EOT Cranes Manufacturing",
                      "Gantry & Jib Cranes",
                      "Industrial Hoists & Lifts",
                      "Customized Lifting Solutions",
                      "Safe & Efficient Performance",
                      "End-to-End Installation & Support"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://ishanvicranes.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeProject === 'rise' && (
          <section className="py-32 relative overflow-hidden border-t border-white/5 animate-fade-in">
            {/* Background accents */}
            <div className="absolute top-1/4 left-0 w-[600px] h-[600px] bg-violet-500/8 rounded-full blur-[200px] pointer-events-none" />
            <div className="absolute bottom-1/4 right-0 w-[500px] h-[500px] bg-cyan-500/8 rounded-full blur-[180px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <div className="text-center mb-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
                  <Sparkles className="w-4 h-4" />
                  Featured Project
                </div>
                <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tight text-white leading-[1.1]">
                  Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Work</span> in Action
                </h2>
                <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light leading-relaxed">
                  Real projects, real results — see how we bring visions to life with stunning, high-performance websites.
                </p>
              </div>

              {/* Showcase Grid */}
              <div className="grid lg:grid-cols-2 gap-16 items-center">

                {/* Left — Device Mockups */}
                <div className="relative flex items-end justify-center gap-6 min-h-[500px]">
                  {/* Glow behind devices */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-br from-violet-500/15 to-cyan-500/15 rounded-full blur-[100px]" />

                  {/* Laptop Mockup */}
                  <div className="relative z-10 animate-float-slow">
                    <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_80px_rgba(139,92,246,0.2)] border border-white/10">
                      <img
                        src={riseLaptop}
                        alt="Rise Institute — Desktop View"
                        className="w-full max-w-[520px] h-auto rounded-2xl"
                      />
                    </div>
                  </div>

                  {/* Mobile Mockup — overlapping */}
                  <div className="absolute -bottom-4 -right-2 md:right-4 z-20 animate-float" style={{ animationDelay: '1.5s' }}>
                    <div className="relative rounded-[1.5rem] overflow-hidden shadow-[0_20px_60px_rgba(14,165,233,0.25)] border border-white/10">
                      <img
                        src={riseMobile}
                        alt="Rise Institute — Mobile View"
                        className="w-[140px] md:w-[180px] h-auto rounded-[1.5rem]"
                      />
                    </div>
                  </div>

                  {/* Floating badge */}
                  <div className="absolute top-4 -left-2 md:left-2 glass-card rounded-2xl border border-white/10 p-3 shadow-2xl z-30 animate-float" style={{ animationDelay: '3s' }}>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center">
                        <Globe className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-white">Live & Online</p>
                        <p className="text-[10px] text-gray-400">riseinstitutes.com</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right — Project Info */}
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6">
                    <span className="w-2 h-2 rounded-full bg-cyan-400" />
                    <span className="text-xs font-bold text-gray-300 uppercase tracking-wider">Educational Institute</span>
                  </div>

                  <h3 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tight leading-[1.15]">
                    Rise Institute<br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Sangli</span>
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed font-light mb-8">
                    We designed a dynamic and modern educational portal for Rise Institute Sangli. The platform highlights their advanced IT courses, expert faculty, and interactive learning environment, providing students with seamless access to resources.
                  </p>

                  {/* Highlights */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    {[
                      "Advanced IT Training Programs",
                      "Expert Faculty & Learning",
                      "Student Resource Portal",
                      "Placement Assistance Integration",
                      "Interactive UI/UX Design",
                      "Responsive Across Devices"
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-300">
                        <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shrink-0">
                          <CheckCircle2 className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-sm font-medium">{item}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <a
                    href="https://riseinstitutes.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 to-cyan-600 text-white font-bold tracking-wide hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(139,92,246,0.3)] hover:shadow-[0_0_60px_rgba(139,92,246,0.5)] no-underline"
                  >
                    <Globe className="w-5 h-5" />
                    Visit Live Site
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}

      </div>

      {/* ═══════════════════════════════════════════════════════
          SECTION — OUR VALUABLE CLIENTS (Marquee)
      ═══════════════════════════════════════════════════════ */}
      <section className="py-20 relative overflow-hidden border-t border-white/5 bg-gradient-to-b from-[#030712] via-[#0A0F1F]/50 to-[#030712]">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[300px] bg-cyan-500/5 rounded-full blur-[150px] pointer-events-none" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
              <Sparkles className="w-4 h-4" />
              Our Valuable Clients
            </div>
            <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-white leading-[1.1]">
              Trusted by <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Industry Leaders</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-xl mx-auto font-light leading-relaxed">
              We're proud to partner with businesses across industries, delivering digital solutions that drive real impact.
            </p>
          </div>
        </div>

        {/* Marquee Container */}
        <div className="relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#030712] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#030712] to-transparent z-10 pointer-events-none" />

          <div className="flex animate-client-marquee w-max">
            {[1, 2].map((set) => (
              <div key={set} className="flex items-center gap-12 md:gap-20 px-6 md:px-10 shrink-0">
                {[
                  { src: logo1, alt: 'VDT Vishwadigitech' },
                 
                  { src: logo3, alt: 'Coders Pixel Innovations', isCodersPixel: true },
                  { src: logo4, alt: 'Rushi Group Of Industries', isRushi: true },
                  { src: logo5, alt: 'Rajaram Food Company', isRajaram: true },
                  { src: logo6, alt: 'Rise Institute Sangli', isRise: true },
                  { src: logo7, alt: 'Sunsspark Industries', isSunsspark: true },
                  // { src: logo8, alt: 'Client Logo' },
                  { src: logo9, alt: 'Ishanvi Cranes', isIshanvi: true },
                  { src: logo10, alt: 'Owlchemy', isOwlchemy: true },
                  { src: logo11, alt: 'HuayuIntelligent', isHuayu: true },
                  // { src: logo12, alt: 'Client Logo' },
                  { src: logo13, alt: 'Versatile Scientist', isVersatile: true },
                  // { src: logo14, alt: 'Gargi Collection' },
                  { src: logo15, alt: 'Pixel11', isPixel11: true, invert: true },
                  { src: logo16, alt: 'चप्पलboot', isChappalBoot: true },
                  // { src: logo17, alt: 'Client Logo' }
                ].map((logo, i) => {
                  const isClickable = true;
                  const content = (
                    <div
                      key={i}
                      className={`group relative flex-shrink-0 w-20 h-20 md:w-28 md:h-28 rounded-2xl bg-white/[0.03] border border-white/[0.06] hover:border-cyan-500/30 flex items-center justify-center p-3 md:p-4 transition-all duration-500 hover:bg-white/[0.08] hover:scale-110 hover:shadow-[0_0_30px_rgba(14,165,233,0.15)] ${isClickable ? 'cursor-pointer' : 'cursor-default'}`}
                      onClick={() => {
                        if (logo.isCodersPixel) {
                          setActiveProject('coderspixel');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isRushi) {
                          setActiveProject('rushigi');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isHuayu) {
                          setActiveProject('huayuintelligent');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isSunsspark) {
                          setActiveProject('sunsspark');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isPixel11) {
                          setActiveProject('pixel11');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isVersatile) {
                          setActiveProject('versatilescientist');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isRajaram) {
                          setActiveProject('rajaram');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isChappalBoot) {
                          setActiveProject('chappalboot');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isOwlchemy) {
                          setActiveProject('owlchemy');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isIshanvi) {
                          setActiveProject('ishanvi');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else if (logo.isRise) {
                          setActiveProject('rise');
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        } else {
                          setActiveProject('anusaya');
                          // Small delay to ensure state updates before scrolling
                          setTimeout(() => {
                            document.getElementById('portfolio-showcase')?.scrollIntoView({ behavior: 'smooth' });
                          }, 50);
                        }
                      }}
                    >
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className={`max-w-full max-h-full object-contain transition-opacity duration-500 drop-shadow-lg ${logo.invert ? 'opacity-80 group-hover:opacity-100 invert brightness-0' : 'opacity-60 group-hover:opacity-100'}`}
                      />
                    </div>
                  );
                  return content;
                })}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION 4 — OUR PROCESS (Vertical Timeline)
      ═══════════════════════════════════════════════════════ */}
      <section className="py-32 relative overflow-hidden">
        {/* Background accents */}
        <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-cyan-500/5 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 left-0 w-[400px] h-[400px] bg-violet-500/5 rounded-full blur-[150px]" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
              <Sparkles className="w-4 h-4" />
              How We Build
            </div>
            <h2 className="text-5xl md:text-6xl font-black mb-6 tracking-tight">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Process</span>
            </h2>
            <p className="text-gray-400 text-xl max-w-2xl mx-auto font-light">
              A battle-tested methodology designed to reduce risk, iterate fast, and launch with maximum impact.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-6">
            {processSteps.map((step, idx) => (
              <div key={idx} className="group relative">
                {/* Connector line */}
                {idx < processSteps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[calc(100%-20%)] h-px bg-gradient-to-r from-white/10 to-transparent z-0" />
                )}

                <div className="relative z-10 flex flex-col items-center text-center">
                  {/* Numbered circle */}
                  <div className={`w-24 h-24 rounded-3xl bg-gradient-to-br ${step.color} flex items-center justify-center mb-8 group-hover:scale-110 group-hover:-rotate-3 transition-all duration-500 shadow-2xl relative`}>
                    <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${step.color} blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-500`} />
                    <step.icon className="w-10 h-10 text-white relative z-10" />
                  </div>

                  {/* Step number */}
                  <span className="text-xs font-black tracking-widest text-cyan-500 mb-3">{step.num}</span>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed font-light">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION 5 — TECH STACK (Floating Pills)
      ═══════════════════════════════════════════════════════ */}
      <section className="py-28 border-y border-white/5 bg-gradient-to-b from-[#0A0F1F] to-[#030712] relative overflow-hidden">
        {/* Dot grid background */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-40" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
              <Sparkles className="w-4 h-4" />
              Tech Stack
            </div>
            <div className="flex items-center justify-center gap-3 mb-6">
              <Cpu className="w-8 h-8 text-cyan-400" />
              <h2 className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9] tracking-tight">Tech Ecosystem</h2>
            </div>
            <p className="text-gray-400 text-lg max-w-xl mx-auto font-light">
              We leverage the most powerful tools in the modern web ecosystem.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-5 max-w-5xl mx-auto">
            {technologies.map((tech, idx) => (
              <div
                key={idx}
                className="group px-7 py-4 rounded-2xl bg-[#0A0F1F] border border-white/[0.06] text-gray-300 font-bold tracking-wide hover:text-white hover:bg-cyan-500/10 hover:border-cyan-500/40 hover:-translate-y-2 hover:shadow-[0_12px_40px_rgba(14,165,233,0.25)] transition-all duration-300 cursor-default flex items-center gap-3"
              >
                <span className="text-xl group-hover:scale-125 transition-transform duration-300">{tech.icon}</span>
                <span>{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════
          SECTION 6 — WHY CHOOSE US (Feature Grid)
      ═══════════════════════════════════════════════════════ */}
      <section className="py-32 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#0EA5E9]/30 bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-bold tracking-wider uppercase mb-8 backdrop-blur-md animate-text-reveal">
              <Sparkles className="w-4 h-4" />
              Why VishwaDigitech
            </div>
            <h2 className="text-5xl md:text-6xl font-black tracking-tight">
              Built for <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0EA5E9] via-[#7DD3FC] to-[#0EA5E9]">Performance</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Zap, title: "Blazing Fast", desc: "Sub-second load times with edge caching, code splitting, and image optimization built-in.", color: "text-amber-400", glow: "group-hover:shadow-[0_0_40px_rgba(251,191,36,0.15)]" },
              { icon: Shield, title: "Enterprise Security", desc: "SSL, OWASP compliance, input sanitization, and regular penetration testing.", color: "text-emerald-400", glow: "group-hover:shadow-[0_0_40px_rgba(52,211,153,0.15)]" },
              { icon: Layers, title: "Scalable Architecture", desc: "Microservices, containerized deployments, and auto-scaling cloud infrastructure.", color: "text-cyan-400", glow: "group-hover:shadow-[0_0_40px_rgba(14,165,233,0.15)]" },
              { icon: Search, title: "SEO Optimized", desc: "Server-side rendering, structured data, and Core Web Vitals optimization out of the box.", color: "text-violet-400", glow: "group-hover:shadow-[0_0_40px_rgba(139,92,246,0.15)]" },
              { icon: GitBranch, title: "Version Controlled", desc: "Git-based workflows, automated CI/CD pipelines, and staging environments.", color: "text-rose-400", glow: "group-hover:shadow-[0_0_40px_rgba(251,113,133,0.15)]" },
              { icon: Cloud, title: "Cloud Native", desc: "Deployed on AWS/GCP with CDN distribution, 99.99% uptime guarantee.", color: "text-blue-400", glow: "group-hover:shadow-[0_0_40px_rgba(96,165,250,0.15)]" }
            ].map((item, idx) => (
              <div key={idx} className={`group relative overflow-hidden rounded-3xl bg-white/[0.02] border border-white/5 hover:border-white/10 p-8 transition-all duration-500 hover:-translate-y-1 ${item.glow}`}>
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/[0.03] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="relative z-10">
                  <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:-rotate-3 transition-all duration-500">
                    <item.icon className={`w-7 h-7 ${item.color}`} />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-white transition-colors">{item.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed font-light group-hover:text-gray-300 transition-colors">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



    </div>
  );
};

export default WebsitesDevelopment;
